'use client';

import { CSSProperties, PropsWithChildren, useEffect, useReducer, useRef, useState } from 'react';

import { Button } from '../Button';

import styles from './Collapsible.module.scss';

type CollapsibleProps = PropsWithChildren<{
  height?: CSSProperties['maxHeight'];
  expandLabel?: string;
  collapseLabel?: string;
  additionalInfo?: string;
}>;

export function Collapsible({
  height,
  expandLabel = 'Show all',
  collapseLabel = 'See less',
  additionalInfo,
  children,
}: CollapsibleProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isExpanded, toggleIsExpanded] = useReducer((state) => !state, false);
  const [isExpandable, setIsExpandable] = useState(false);

  useEffect(() => {
    setIsExpandable(
      Boolean(containerRef.current && containerRef.current.offsetHeight < containerRef.current.scrollHeight),
    );
  }, []);

  return (
    <>
      <div ref={containerRef} data-expanded={isExpanded} className={styles.container} style={{ maxHeight: height }}>
        {children}
      </div>
      {isExpandable && (
        <div className={styles.cta}>
          {!isExpanded && additionalInfo && <span className={styles.info}>{additionalInfo}</span>}
          <Button variant="text" onClick={toggleIsExpanded}>
            {isExpanded ? collapseLabel : expandLabel}
          </Button>
        </div>
      )}
    </>
  );
}
